/* eslint-disable @typescript-eslint/no-explicit-any */
import { useStore } from 'hooks/useRootStore';
import { observer } from 'mobx-react-lite';
import { FormProvider, useForm } from 'react-hook-form';
import { useMyTranslations } from 'hooks/useMyTranslations';
import { useThrottleFn } from 'hooks/useThrottleFn';
import { ControlledInput } from 'components/Inputs/ControlledInput';
import { confirmWithCodePopUpTranslations } from './translations';
import { ConfirmWithCodePopUpFormFields, ConfirmWithCodePopUpTransFields } from './types';
import styles from './confirmWithCodePopUp.module.scss';

export const ConfirmWithCodePopUp = observer(function () {
  const {
    popUpStore: { closePopUp, title, description, buttonLabel, callBack },
  } = useStore();

  const { t } = useMyTranslations<ConfirmWithCodePopUpTransFields>([confirmWithCodePopUpTranslations.name]);

  const useFormMethods = useForm<ConfirmWithCodePopUpFormFields>();

  const { handleSubmit } = useFormMethods;

  const handleSave = useThrottleFn(({ code }: ConfirmWithCodePopUpFormFields) => {
    callBack && callBack.cb({ verificationCode: code });
  });

  return (
    <div className={styles.content}>
      <p className={styles.title}>{title}</p>
      <p className={styles.desc}>{description}</p>
      <FormProvider {...(useFormMethods as any)}>
        <ControlledInput
          name='code'
          type='text'
          placeholder={t('placeholder')}
          showErrorIcon={false}
          required
          autoFocus
          autoComplete='off'
          classNameProp={styles.input}
        />
      </FormProvider>
      <footer className={styles.footer}>
        <button type='reset' className={styles.btnReset} onClick={closePopUp}>
          {t('cancel')}
        </button>
        <button type='button' className={styles.btnSubmit} onClick={handleSubmit(handleSave)}>
          {buttonLabel}
        </button>
      </footer>
    </div>
  );
});
